import { PaymentMethod } from '@frontend/api-payment-plans';
import { classNames } from '@frontend/string';
import { Prettify } from '@frontend/types';
import { PaymentMethodAch, PaymentMethodAchProps } from '../payment-method/payment-method-ach';
import { AchNonVerifiedMessage } from './ach-non-verified-message';
import { PaymentMethodsListContainer } from './payment-methods-list-container';

export type PaymentMethodListAchProps = Prettify<
  Omit<PaymentMethodAchProps, 'isSelected' | 'paymentMethod'> & {
    isLoading: boolean;
    personId: string;
    selectedPaymentMethod: PaymentMethod | null;
    paymentMethods: PaymentMethod[];
    invalidatePaymentMethodsByPerson: (patientId?: string, locationId?: string) => void;
    className?: string;
  }
>;
export const PaymentMethodListAch = ({
  isLoading,
  paymentMethods,
  selectedPaymentMethod,
  personId,
  invalidatePaymentMethodsByPerson,
  className,
  ...rest
}: PaymentMethodListAchProps) => {
  return (
    <PaymentMethodsListContainer isLoading={isLoading} className={classNames('payment-methods__list-ach', className)}>
      {paymentMethods.map((pm) => (
        <PaymentMethodAch key={pm.id} {...rest} isSelected={selectedPaymentMethod?.id === pm.id} paymentMethod={pm} />
      ))}
      <AchNonVerifiedMessage
        invalidatePaymentMethodsByPerson={invalidatePaymentMethodsByPerson}
        paymentMethods={paymentMethods}
        personId={personId}
      />
    </PaymentMethodsListContainer>
  );
};
